module.exports = __webpack_public_path__ + "img/2.0b7c0c5d.jpg";